import request from "@/utils/request";

export default function adminGetNews(current=1, size=10, params) {
    return request({
        url: `/news/agencyGetNews/`+current+`/`+size,
        method: 'get',
        params
    })
}
